import React, { Fragment } from "react";
import {socialNetwork} from "../../data";

const ContactInfo = ({ address }) => {
  return (
    <Fragment>
      <div className="widget-item m-0">
        <address>
          <span dangerouslySetInnerHTML={{ __html: address }} />
        </address>
      </div>
      <div className="member-social-icons mt-30">
        {socialNetwork.map((item, index) => {
          return (
            <a
              key={index}
              href={item.url}
              target="_blank"
              rel="noopener noreferrer"
            >
              {item.icon}
            </a>
          );
        })}
      </div>
    </Fragment>
  );
};

export default ContactInfo;
